let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6vNg8")).then(() => parcelRequire('aC5Dm'));